import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import DeleteIcon from 'apollo-react-icons/Trash';
import React from 'react';

const useStyles = makeStyles({
  actions: {
    display: 'flex',
    textAlign: 'center',
  },
});

const ActionCell = ({ row }) => {
  const classes = useStyles();

  const handleDeleteButtonClick = () => {
    row.deleteRow && row.deleteRow({ rowId: row.rowId });
    row.validate && row.validate();
  };

  return (
    <div className={classes.actions}>
      <IconButton onClick={handleDeleteButtonClick} aria-label="Delete">
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

export default ActionCell;
